// StatusStepperPopover.tsx
import React from 'react';
import {
  Popover,
  Stepper,
  Step,
  StepLabel,
  Box,
  Typography,
} from '@material-ui/core';
import StepIconSimple from './StepIconSimple';

interface Props {
  anchorEl: HTMLElement | null;
  trackingStatus: any | [];
  onClose: () => void;
}

export default function StatusStepperPopover({
  anchorEl,
  trackingStatus,
  onClose,
}: Props) {

  const getActiveStepFromTracking = (trackingStatus: any[]) => {
    // first step which is NOT completed
    const firstIncompleteIndex = trackingStatus?.findIndex(
      (step) => !step.completed
    );

    // if all completed, return last index + 1
    return firstIncompleteIndex === -1
      ? trackingStatus?.length
      : firstIncompleteIndex;
  };

  const hasTracking = Array.isArray(trackingStatus) &&
    trackingStatus?.length > 0;


  return (
    <>
      {hasTracking && (
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={onClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
          <Box p={2} width={180}>
            <Stepper
              orientation="vertical"
              activeStep={getActiveStepFromTracking(trackingStatus)}
            >
              {trackingStatus.map((step: any, index: number) => (
                <Step key={step.label} completed={step.completed}>
                  <StepLabel StepIconComponent={StepIconSimple}>
                    <Typography
                      style={{
                        fontSize: 13,
                        fontWeight:
                          !step.completed &&
                            index === getActiveStepFromTracking(trackingStatus)
                            ? 600
                            : 400,
                        color:
                          !step.completed &&
                            index === getActiveStepFromTracking(trackingStatus)
                            ? '#1976d2'
                            : '#424242',
                      }}
                    >
                      {step.label}
                    </Typography>
                  </StepLabel>
                </Step>
              ))}
            </Stepper>

          </Box>
        </Popover>
      )}
    </>
  );
}
